import {API_URL,Accept} from '../constants.js';
import {notify} from 'react-notify-toast';
const  markinoutApi=(action,component)=>{
  const Authorization='bearer '+localStorage.getItem('token');
const rider_id=localStorage.getItem('rider_id');
  fetch(`${API_URL}markinout`,{
    method:'POST',
    headers:{"Content-Type": "application/json",Accept,Authorization},
        body:JSON.stringify({rider_id,action:action+""})
        }).then(function(response){
          if(!response.ok){
              notify.show('Network Failure','error');
          }
            return response.json();
        })
        .then(function(data) {
              if(data[0]&&data[0].status==='success'){
                  action=action ? 0 : 1;
                  let mark=action ? 'Mark In' : 'Mark Out';
                  component.setState({mark,action});
                  localStorage.setItem('mark',JSON.stringify({mark,action}));
              }
        })
}
export default markinoutApi;



// WEBPACK FOOTER //
// ./src/utility/api/markinoutApi.js